module.exports = __webpack_public_path__ + "img/zhengjiaguangchang.c66035ba.jpg";